require('es6-promise').polyfill();
require('fetch-everywhere');

// The default URL is also defined in package.json

// Dev
let API_ROOT = `https://hat6ra8gf0.execute-api.us-east-1.amazonaws.com/dev/`;

if (process.env.NODE_ENV === 'production') {
  API_ROOT = `https://nwx9t9qnxg.execute-api.us-east-1.amazonaws.com/prod/`;
}

// IE6 polyfill support
require('core-js/modules/es6.symbol');
// IE6 polyfill support

const callApi = (endpoint, options) => {
  let url = API_ROOT + endpoint;
  if (endpoint.indexOf('http') === 0) url = endpoint;

  return fetch(url, options).then((response) => {
    // JSON response
    if (options.headers && options.headers.Accept === 'application/json') {
      return response
        .json()
        .then(
          (json) => (response.ok ? json : Promise.reject({ ...json, ...{ status: response.status } })),
          (error) => Promise.reject({ message: error, status: response.status }),
        );
    }

    return response.ok
      ? response.json().then((json) => json, (error) => response)
      : response.json().then((json) => Promise.reject(json), (error) => Promise.reject(response));
  });
};

// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = Symbol('Call API');

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
export default (store) => (next) => (action) => {
  const callAPI = action[CALL_API];

  if (callAPI && callAPI.options) {
    callAPI.options = { ...callAPI.options, mode: 'cors' };
  }

  if (typeof callAPI === 'undefined') {
    return next(action);
  }

  let { endpoint } = callAPI;
  const { types, options } = callAPI;

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState());
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }
  if (!types.every((type) => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.');
  }

  const actionWith = (data) => {
    const finalAction = { ...action, ...data };
    delete finalAction[CALL_API];
    return finalAction;
  };

  const [requestType, successType, failureType] = types;
  next(actionWith({ type: requestType }));

  return callApi(endpoint, options).then(
    (response) =>
      next(
        actionWith({
          response,
          // status: response.status, //disabled if we don't care about status
          type: successType,
        }),
      ),
    (error) =>
      next(
        actionWith({
          fullError: error,
          type: failureType,
          status: error.status,
          error: error.detail || error.message || 'Uncaught error.',
        }),
      ),
  );
};



// WEBPACK FOOTER //
// ./src/middleware/api.js